// Maxa.StockByLocation - model pointing at the SuiteScript 2 service.
// Same pattern as the existing partner extensions on the site (Model + SS2Model).
define('Maxa.StockByLocation.StockByLocation.SS2Model', [
    'Backbone',
    'Utils'
], function (
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('Modules/StockByLocation/SuiteScript2/StockByLocation.Service.ss'),
            true
        )
    });
});
